import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from './cn.js';
/**
 * A key or shortcut: Ctrl K in the search box, Enter / Esc beside an editable
 * heading, shortcuts in a menu. Mono 11 px on `muted`.
 */
export function Kbd({ className, ...props }) {
    return (_jsx("kbd", { "data-slot": "kbd", className: cn('inline-flex h-5 items-center whitespace-nowrap rounded-sm border border-border bg-muted px-1.5 font-mono text-micro font-medium normal-case tracking-normal text-muted-foreground', className), ...props }));
}
//# sourceMappingURL=kbd.js.map